import { useEffect } from "react";
import { MapContainer, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";
import MapTileLayer from "../shared/MapTileLayer";

interface Quote {
  postcode: string;
  // other fields…
}
interface Props {
  // after geocoding you’ll pass an array of [lat, lng, intensity]
  points: [number, number, number][];
}

function HeatmapLayer({ points }: { points: [number, number, number][] }) {
  const map = useMap();

  useEffect(() => {
    console.log("HeatmapLayer useEffect", points);
    if (!map || points.length === 0) return;

    map.invalidateSize();

    // create heat layer with your points
    const heat = (L as any).heatLayer(points, {
        radius: 25,   // cluster radius in pixels
        blur: 15,     // blur factor
        maxZoom: 17,  // max zoom for intensity
        // gradient: {0.2: 'blue', 0.5: 'lime', 1.0: 'red'},
        // gradient: {
        //     0.2: "#ffffb2",
        //     0.4: "#fed976",
        //     0.6: "#fd8d3c",
        //     0.8: "#f03b20",
        //     1.0: "#bd0026",
        // },
    });

    heat.addTo(map);

    // fit map to data bounds on load
    const latlngs = points.map(p => [p[0], p[1]]) as [number, number][];
    map.fitBounds(latlngs);

    return () => {
      map.removeLayer(heat);
    };
  }, [map, points]);

  return null;
}

export default function QuotesHeatmap({ points }: Props) {
  return (
    <MapContainer
      center={[54.0, -2.0]} // fallback centre
      zoom={6}
      style={{ height: "100%", width: "100%" }}
    >
      <MapTileLayer />
      <HeatmapLayer points={points} />
    </MapContainer>
  );
}
